export const PESO_MAXIMO_DE_DOCUMENTO = 8 * 1024 * 1024;

const MARGEN = 1024;

export async function problemaDelPdf(archivo: Blob): Promise<string | null> {
  if (archivo.size === 0) {
    return 'EL ARCHIVO ESTÁ VACÍO.';
  }
  if (archivo.size > PESO_MAXIMO_DE_DOCUMENTO) {
    return 'EL PDF PESA MÁS DE 8 MB.';
  }
  const inicio = await texto(archivo.slice(0, MARGEN));
  if (!inicio.includes('%PDF-')) {
    return 'ESE ARCHIVO NO ES UN PDF.';
  }
  const final = await texto(archivo.slice(Math.max(0, archivo.size - MARGEN)));
  if (!final.includes('%%EOF')) {
    return 'EL PDF ESTÁ INCOMPLETO O DAÑADO. VUELVA A EXPORTARLO.';
  }
  return null;
}

function texto(trozo: Blob): Promise<string> {

  return new Promise((resolver, rechazar) => {
    const lector = new FileReader();
    lector.onload = () => resolver(new TextDecoder('latin1').decode(lector.result as ArrayBuffer));
    lector.onerror = () => rechazar(lector.error);
    lector.readAsArrayBuffer(trozo);
  });
}

export function enFecha(dia: string | null): string {
  if (!dia) {
    return '—';
  }
  const [anio, mes, d] = dia.split('-');
  return `${d}/${mes}/${anio}`;
}

export function huellaCorta(huella: string): string {
  return `${huella.slice(0, 12)}…`;
}
